import { useMemo } from 'react';

import { USPRotator } from '~/features/navigation/components/N21MetaHeader/components/usp-rotator';

import styles from './metaHeaderItems.module.css';

import type { MetaHeaderItemUnion } from '../../types';
import { isBasicMetaMenuItem, isTextMetaMenuItem, isUspListMetaMenuItem } from '../../types';

interface MetaHeaderItemsProps {
	items: MetaHeaderItemUnion[];
}

export const MetaHeaderItems = ({ items = [] }: MetaHeaderItemsProps) => {
	const uspListItems = items.filter(isUspListMetaMenuItem);

	const allUspItems = uspListItems.flatMap((uspList) => uspList.items);

	const animatableItems = useMemo(() => {
		const basics = items.filter(isBasicMetaMenuItem);
		const texts = items.filter(isTextMetaMenuItem);
		return [...basics, ...texts];
	}, [items]);

	if (allUspItems.length > 0) {
		return (
			<div className={styles.root}>
				<USPRotator items={allUspItems} />
			</div>
		);
	}

	if (!items.length) {
		return null;
	}

	return (
		<div className={styles.root}>
			<USPRotator items={animatableItems} />
		</div>
	);
};
